import type { BuildB2CNavigationModelOptions } from './types'

import { ROLE } from '../B2B/constants'

const isStandardOrHigherRole = (role: string): boolean => {
  return [ROLE.Standard, ROLE.Admin, ROLE.Staff].some(
    (allowedRole) => allowedRole === role
  )
}

export const hasStandardOrHigherInOtherAccounts = (
  userState: BuildB2CNavigationModelOptions['userState']
): boolean => {
  const currentAccountId = Number(userState.account?.id)
  const hasCurrentAccountId =
    Number.isFinite(currentAccountId) && currentAccountId > 0

  return (userState.currentUser.accountsRoles || []).some((accountRole) => {
    const isOtherAccount = hasCurrentAccountId
      ? accountRole.accountId !== currentAccountId
      : true

    return isOtherAccount && isStandardOrHigherRole(accountRole.role)
  })
}
